<template>
    <b-container fluid class="the-detail__dashboard">
      <b-row cols="1" cols-md="2" cols-lg="4" class="the-detail__dashboard__quickinfo">
        <b-col class="p-2">
          <div class="contentcontainer the-detail__dashboard__quickinfo__item">
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="siteDetail.data.app_type === 'Joomla' && siteDetail.data.core_need_update" src="/images/icon/sitedetail/dashboard/joomla-danger.svg"/>
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="siteDetail.data.app_type === 'Joomla' && !siteDetail.data.core_need_update" src="/images/icon/sitedetail/dashboard/joomla-success.svg"/>
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="siteDetail.data.app_type === 'Wordpress' && siteDetail.data.core_need_update" src="/images/icon/sitedetail/dashboard/wordpress-danger.svg"/>
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="siteDetail.data.app_type === 'Wordpress' && !siteDetail.data.core_need_update" src="/images/icon/sitedetail/dashboard/wordpress-success.svg"/>
            {{siteDetail.data.app_version}}
            <div class="core-update" v-show="siteDetail.data.core_need_update">
              <button v-if="siteDetail.data.process_state === 0" v-on:click="localUpdateCoreForSite" class="btn btn--primary">
                {{$t('site.coreupdateto')}} {{siteDetail.data.core_update_to}}
              </button>
              <div class="btn btn--primary" v-if="coreUpdateProgress !== null && siteDetail.data.process_state !== 0">
                <font-awesome-icon :icon="['fal','spinner']" pulse></font-awesome-icon> {{ coreUpdateProgress }} %
              </div>
            </div>
          </div>
        </b-col>
        <b-col class="p-2">
          <div class="contentcontainer the-detail__dashboard__quickinfo__item">
            <img class="the-detail__dashboard__quickinfo__item__image" src="/images/icon/sitedetail/dashboard/php-success.svg" v-if="phpVersionState" />
            <img class="the-detail__dashboard__quickinfo__item__image" src="/images/icon/sitedetail/dashboard/php-danger.svg" v-else />
            {{ shortPhpVersion }}
          </div>
        </b-col>
        <b-col class="p-2">
          <div class="contentcontainer the-detail__dashboard__quickinfo__item">
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="tlsDaysRemaining > 30" src="/images/icon/sitedetail/dashboard/tls-success.svg"/>
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="tlsDaysRemaining > 0 && tlsDaysRemaining <= 30" src="/images/icon/sitedetail/dashboard/tls-warning.svg"/>
            <img class="the-detail__dashboard__quickinfo__item__image" v-if="tlsDaysRemaining <= 0" src="/images/icon/sitedetail/dashboard/tls-danger.svg"/>
            <span v-if="siteDetail.data.tls_enabled">
              <span v-if="tlsDaysRemaining <= 0">
                {{$t('site.tlsexpired') }}
              </span>
              <span v-else>
                {{ $tc('site.daysremaning', tlsDaysRemaining, {n: tlsDaysRemaining}) }}
              </span>
            </span>
            <span v-else>
                {{$t('site.notls') }}
            </span>
          </div>
        </b-col>
        <b-col class="p-2">
          <div class="contentcontainer the-detail__dashboard__quickinfo__item">
            <img class="the-detail__dashboard__quickinfo__item__image" src="/images/icon/sitedetail/dashboard/monitoring-success.svg" v-if="siteDetail.data.state !== 2"/>
            <span v-if="siteDetail.data.state !== 2">Online</span>
            <img class="the-detail__dashboard__quickinfo__item__image" src="/images/icon/sitedetail/dashboard/monitoring-danger.svg" v-if="siteDetail.data.state === 2"/>
            <span v-if="siteDetail.data.state === 2">Offline</span>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-lg-5">
        <note-section></note-section>
      </b-row>
      <b-row>
        <extensions-section
          v-bind:show-full-list-link="true"
          v-bind:show-back-link="false"
          v-bind:show-updates="true"
          v-bind:show-autoupdate="false"
          v-on:close-detail="close"
        >
        </extensions-section>
      </b-row>
      <b-row>
        <backup-section></backup-section>
      </b-row>
      <b-row align-h="end">
        <b-col cols="auto">
          <button v-on:click="localRemoveSite" class="btn btn--danger">
            <span class="btn__icon">
                <font-awesome-icon :icon="['fal','trash']"></font-awesome-icon>
            </span>
            {{$t('site.removesite') }}
          </button>
        </b-col>
      </b-row>
    </b-container>

</template>

<script>

import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'

import BackupSection from './BackupSection'
import ExtensionsSection from './ExtensionsSection'
import NoteSection from './NoteSection'

import Moment from 'moment'

export default {

  name: 'SiteDetailDashboard',

  components: {
    BackupSection,
    ExtensionsSection,
    NoteSection
  },

  computed: {

    ...mapState('site', [
      'siteDetail',
      'showDetailPage'
    ]),

    ...mapGetters('progress', [
      'siteCoreUpdateProgress'
    ]),

    coreUpdateProgress () {
      return this.siteCoreUpdateProgress(this.siteDetail.id)
    },

    tlsDaysRemaining () {
      if (!this.siteDetail.data.tls_expiration) {
        return 0
      }

      return Moment(this.siteDetail.data.tls_expiration).diff(new Moment(), 'days')
    },

    shortPhpVersion () {
      const regex = /^(\d{1,2}\.\d{1,2}\.\d{1,2})/
      const shortVersion = regex.exec(this.siteDetail.data.phpversion)

      if (!shortVersion) {
        return ''
      }

      return shortVersion[0]
    },

    phpVersionState () {
      const regex = /^(\d{1,2})\.(\d{1,2})\.(\d{1,2})/

      const versionsplit = regex.exec(this.siteDetail.data.phpversion)

      if (!versionsplit) {
        return true
      }

      // Major branch
      if (parseInt(versionsplit[1]) < 7) {
        return false
      }

      if (parseInt(versionsplit[1]) === 7 && parseInt(versionsplit[2]) < 4) {
        return false
      }

      // PHP 7 EOL
      if (parseInt(versionsplit[1]) === 7 && new Date() > new Date('2022-11-28')) {
        return false
      }

      return true
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPage',
      'showSiteDetailPageBackups',
      'showSiteDetailPageExtensions',
      'showSiteDetailPageConfiguration',
      'setSiteDetailId'
    ]),

    ...mapActions('site', [
      'refreshSiteData'
    ]),

    ...mapActions('core', [
      'updateCoreForSite'
    ]),

    ...mapMutations('progress', [
      'setCoreUpdateProgress'
    ]),

    close () {
      this.closeSiteDetailPage()
    },

    localRefreshSiteData () {
      this.refreshSiteData(this.siteDetail.id)
    },

    localRemoveSite () {
      this.$router.push({
        name: 'siteDestroy',
        params: {
          id: this.siteDetail.id
        }
      })
      this.setSiteDetailId(0)
    },
    localUpdateCoreForSite () {
      if (this.siteDetail.data.process_state === 0) {
        this.setCoreUpdateProgress({ siteId: this.siteDetail.id, progress: 0 })
        this.updateCoreForSite(this.siteDetail.id).then(
          response => {
            this.siteDetail.data.process_state = response.data.process_state
          }
        )
      }
    }
  }
}
</script>
